export default {
	name: "ListingPermissionModal",
	components: {},
	
	data() {
		return {
			isShown: false
		}
	},
}